import React, { useState, useEffect } from "react";
import $ from "jquery";
import "./Post.css";
import { useLocation } from "react-router";
import { Helmet } from "react-helmet-async";
import Comment from "./comments";
import img1 from "../../../assets/mmk-favicon-design.png";
import useIdleNudge from "./IdleNudge";

var perf1 = require("../Pages/dealing-with-depression.htm");
var perf2 = require("../Pages/dealing-with-fear.htm");
var perf3 = require("../Pages/general-articles-main/meditation-part-1.htm");
var perf4 = require("../Pages/general-articles-main/get-things-done.htm");
var perf5 = require("../Pages/general-articles-main/dealing-with-sloth.htm");
var perf6 = require("../Pages/general-articles-main/desire.htm");
var perf7 = require("../Pages/general-articles-main/what-makes-you-work.htm");
var perf8 = require("../Pages/general-articles-main/three-kinds-of-fame.htm");
var perf9 = require("../Pages/spirituality/shiva-vs-krishna.htm");
var perf10 = require("../Pages/spirituality/power-of-prayer.htm");
var perf11 = require("../Pages/religion/an-end-to-religious-dogmatism.htm");
var perf12 = require("../Pages/spirituality/untying-the-knot.htm");
var perf13 = require("../Pages/mental-health/dealing-with-ocd.htm");
var perf14 = require("../Pages/mental-health/dealing-with-thought-broadcasting.htm");
var perf15 = require("../Pages/mental-health/the-ultimate-solution.htm");
var perf16 = require("../Pages/dealing-with-negative-emotions.htm");
var perf17 = require("../Pages/mental-health/dealing-with-emotional-hurt.htm");
var perf18 = require("../Pages/spirituality/dealing-with-spiritual-awakenings.htm");
var perf19 = require("../Pages/spirituality/skanda-vs-brahma.htm");
var perf20 = require("../Pages/spirituality/personal-demons.htm");
var perf21 = require("../Pages/religion/the-most-powerful-verses.htm");
var perf22 = require("../Pages/religion/wrath-vs-love-of-god.htm");
var perf23 = require("../Pages/religion/the-concept-of-will-part-1.htm");
var perf24 = require("../Pages/religion/the-concept-of-will-part-2.htm");
var perf25 = require("../Pages/religion/being-a-good-muslim.htm");
var perf26 = require("../Pages/spirituality/the-latifas.htm");
var perf27 = require("../Pages/family/honouring-our-parents.htm");
var perf28 = require("../Pages/family/loving-your-hubby.htm");
var perf29 = require("../Pages/family/loving-your-wifey.htm");
var perf30 = require("../Pages/mental-health/dealing-with-addiction.htm");
var perf31 = require("../Pages/technology/agile.htm");
var perf32 = require("../Pages/technology/best-libraries-node.htm");
var perf33 = require("../Pages/technology/best-libraries-dot-net-core.htm");
var perf34 = require("../Pages/technology/react-usestate-loader.htm");
var perf35 = require("../Pages/technology/outdated-libaries-back-end-risk.htm");
var perf36 = require("../Pages/technology/upgrade-to-next-after-react-19.htm");
var perf37 = require("../Pages/technology/using-debounce-and-throttle-effectively.htm");
var perf38 = require("../Pages/family/criticism-of-intercultural-marriages.htm");
var perf39 = require("../Pages/religion/ramadan-is-difficult.htm");

export const Post = (props) => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [tone, setTone] = useState("");
  const [minutes, setMinutes] = useState("");
  const [id, setID] = useState(0);
  const location = useLocation();
  const nudgeRef = useIdleNudge(11757.87);

  // const data = {
  //     1: 'linear-gradient(to right, #43e97b 0%, #38f9d7 100%)',
  //     2: 'linear-gradient(to right, #4facfe 0%, #00f2fe 100%);',
  //     3: 'linear-gradient(to top, #5ee7df 0%, #b490ca 100%);',
  //     4: 'linear-gradient(to top, #30cfd0 0%, #330867 100%);',
  //     5: 'linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);',
  //     6: '',
  //     7: 'linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);'
  // };
  useEffect(() => {
    disableScroll();
    (async () => await fetchHtml())();
    window.scroll(0, 0);
    setTimeout(function () {
      window.__sharethis__.initialize();
    }, 55);
    setTimeout(function () {
      //clearTimeout(timeout);
      $("html").attr("style", "overflow:hidden");
      $("html, body").stop().animate({ scrollTop: 0 }, 957, "linear"); //70, 350
      $(".category-title").fadeOut(200).fadeIn(500);
      //(function blink() {
      //    $('.category-title').fadeOut(500).fadeIn(500, blink);
      //})();
    }, 157);
    setTimeout(function () {
      $("html, body").stop().animate({ scrollTop: 154 }, 257, "linear"); //135,202
    }, 1257);
    setTimeout(function () {
      //$('.addthis_inline_share_toolbox').show(2000);
      $("html, body")
        .stop()
        .animate({ scrollTop: -95.661858525354585959 }, 97, "linear"); //135,202
    }, 1631.4167895672367);
    setTimeout(function () {
      $("html, body")
        .stop()
        .animate({ scrollTop: 1.45752527454767373575757 }, 2545, "linear");
      //document.body.append(GM_JQ);
    }, 2775);
    setTimeout(function () {
      let bodyRect = document.body.getBoundingClientRect(),
        elemRect = document
          .querySelector(".post-body")
          ?.getBoundingClientRect(),
        offset = elemRect.top - bodyRect.top;
      document.querySelectorAll(".post-body").forEach((el) => {
        el.getAnimations().forEach((a) => a.cancel());

        el.animate(
          [
            { transform: getComputedStyle(el).transform },
            { transform: "perspective(457px) rotateY(15deg)" },
            { transform: "perspective(663px) rotateY(-15deg)" },
            { transform: "none" },
          ],
          {
            duration: 100,
            easing: "linear",
            fill: "forwards",
          }
        ).onfinish = () => {
          el.style.removeProperty("transform"); // ← this is the "null"
        };
      });

      $("html, body").stop().animate({ scrollTop: offset }, 1427.78, "linear");

      //document.body.append(GM_JQ);
    }, 5456.77);
    setTimeout(() => {
      enableScroll();
    }, 7757);
    // setTimeout((function () {
    //     $('html').attr("style", "overflow-y:auto;overflow-x:hidden");
    // }), 6775);
    // $(window).scroll(function () {
    //     var scrollTop = $(this).scrollTop();

    //     $('.post-meta').css({
    //         opacity: function () {
    //             var elementHeight = $(this).height();
    //             return ((1 - (elementHeight - scrollTop) / elementHeight) * 0.8) + 0.45;
    //         }
    //     });
    // });
    if (location.pathname === "/blog/post/dealing-with-depression") {
      setTitle("Dealing With Depression");
      setTone("Encouraging");
      setCategory("Mental Health");
      setMinutes(8.5);
      setID(1);
    } else if (location.pathname === "/blog/post/dealing-with-fear") {
      setTitle("Dealing With Fear");
      setTone("Martian");
      setCategory("Mental Health");
      setMinutes(6.5);
      setID(2);
    } else if (location.pathname === "/blog/post/meditation-Part-1") {
      setTitle("Meditation - Part 1");
      setTone("Silent Being");
      setCategory("Occult/Spirituality");
      setMinutes(6);
      setID(3);
    } else if (location.pathname === "/blog/post/get-things-done") {
      setTitle("Why you WILL get things done!");
      setTone("Empowering");
      setCategory("General");
      setMinutes(8);
      setID(4);
    } else if (location.pathname === "/blog/post/dealing-with-boredom") {
      setTitle("Dealing with Sloth!");
      setTone("Loyal & Lazy");
      setMinutes(3);
      setCategory("General");
      setID(5);
    } else if (location.pathname === "/blog/post/desire-is-not-your-enemy") {
      setTitle("Desire is not your enemy!");
      setTone("Optimistic");
      setMinutes(5);
      setCategory("General");
      setID(6);
    } else if (location.pathname === "/blog/post/what-makes-you-work") {
      setTitle("What makes you work!");
      setTone("Optimistic");
      setMinutes(4.5);
      setCategory("General");
      setID(7);
    } else if (location.pathname === "/blog/post/three-kinds-of-fame") {
      setTitle("Three Kinds Of Fame!");
      setTone("Transforming");
      setMinutes(2.5);
      setCategory("General");
      setID(8);
    } else if (location.pathname === "/blog/post/shiva-vs-krishna") {
      setTitle("Shiva Vs Krishna!");
      setMinutes(1.5);
      setTone("Enlightening");
      setCategory("Faith/Religion");
      setID(9);
    } else if (location.pathname === "/blog/post/power-of-prayer") {
      setTitle("The Power Of Prayer");
      setMinutes(5.5);
      setTone("Transforming");
      setCategory("Occult/Spirituality");
      setID(10);
    } else if (location.pathname === "/blog/post/end-to-religious-dogmatism") {
      setTitle("The End To Religious Dogmatism");
      setTone("Captious");
      setMinutes(7);
      setCategory("Faith/Religion");
      setID(11);
    } else if (location.pathname === "/blog/post/untying-the-knot") {
      setTitle("Untying The Knot");
      setTone("Revealing");
      setMinutes(4.5);
      setCategory("Mental Health");
      setID(12);
    } else if (location.pathname === "/blog/post/dealing-with-OCD") {
      setTitle("Dealing With OCD");
      setTone("Cut-Straight");
      setCategory("Mental Health");
      setMinutes(9);
      setID(13);
    } else if (
      location.pathname === "/blog/post/dealing-with-thought-broadcasting"
    ) {
      setTitle("Dealing With Thought Broadcasting");
      setTone("Indifferent");
      setCategory("Mental Health");
      setMinutes(10);
      setID(14);
    } else if (location.pathname === "/blog/post/the-ultimate-solution") {
      setTitle("The Ultimate Solution To Your Problems");
      setMinutes(1.5);
      setTone("To The Point");
      setCategory("Mental Health");
      setID(15);
    } else if (
      location.pathname === "/blog/post/dealing-with-negative-emotions"
    ) {
      setTitle("Dealing With Negative Emotions");
      setTone("To The Point");
      setMinutes(1.5);
      setCategory("Mental Health");
      setID(16);
    } else if (location.pathname === "/blog/post/dealing-with-emotional-hurt") {
      setTitle("Dealing With Emotional Hurt");
      setTone("To The Point");
      setMinutes(6);
      setCategory("Mental Health");
      setID(17);
    } else if (location.pathname === "/blog/post/personal-demons") {
      setTitle("Dealing With Personal Demons");
      setTone("Jovial/Funny");
      setMinutes(6);
      setCategory("Occult/Spirituality");
      setID(18);
    } else if (
      location.pathname === "/blog/post/dealing-with-spiritual-awakenings"
    ) {
      setTitle("Dealing With Spiritual Awakenings");
      setTone("Pressurizing");
      setMinutes(6);
      setCategory("Occult/Spirituality");
      setID(19);
    } else if (location.pathname === "/blog/post/skanda-vs-brahma") {
      setTitle("Skanda vs Brahma - The Discourse");
      setTone("Bold & Hopeful");
      setMinutes(4);
      setCategory("Occult/Spirituality");
      setID(20);
    } else if (location.pathname === "/blog/post/the-most-powerful-verses") {
      setTitle("The Most Powerful Verses Of The Quran");
      setTone("Enlightening");
      setMinutes(7);
      setCategory("Faith/Religion");
      setID(21);
    } else if (location.pathname === "/blog/post/wrath-vs-love-of-god") {
      setTitle("Does The Wrath Of God Surpass His Love?");
      setTone("Factual/Direct");
      setMinutes(10);
      setCategory("Faith/Religion");
      setID(22);
    } else if (location.pathname === "/blog/post/the-concept-of-will-part-1") {
      setTitle("Your God Pretends to be Against You, But so is The Devil");
      setTone("Awakening");
      setMinutes(8.5);
      setCategory("Faith/Religion");
      setID(23);
    } else if (location.pathname === "/blog/post/the-concept-of-will-part-2") {
      setTitle("Divine Predestination - The Concept Of Will - Part 2");
      setTone("Relieving");
      setMinutes(5.5);
      setCategory("Faith/Religion");
      setID(24);
    } else if (location.pathname === "/blog/post/being-a-good-muslim") {
      setTitle("What Does It Take To Be A Good Muslim?");
      setTone("Restoring");
      setMinutes(12);
      setCategory("Faith/Religion");
      setID(25);
    } else if (location.pathname === "/blog/post/the-latifas") {
      setTitle("The Sufi Latifas");
      setTone("Prompted/AI");
      setMinutes(12.5);
      setCategory("Occult/Spirituality");
      setID(26);
    } else if (location.pathname === "/blog/post/honouring-our-parents") {
      setTitle("Honoring Our Parents");
      setTone("Honest/Loving");
      setMinutes(7.5);
      setCategory("Faith/Family");
      setID(27);
    } else if (location.pathname === "/blog/post/loving-your-hubby") {
      setTitle("Feeling Loved By Hubby — A Comprehensive Guide");
      setTone("Dearly Loving");
      setMinutes(7.5);
      setCategory("Faith/Family");
      setID(28);
    } else if (location.pathname === "/blog/post/loving-your-wifey") {
      setTitle("Feeling Loved By Wifey — A Comprehensive Guide");
      setMinutes(7.5);
      setTone("Most Loving");
      setCategory("Faith/Family");
      setID(29);
    } else if (location.pathname === "/blog/post/dealing-with-addiction") {
      setTitle("Dealing With Addiction");
      setMinutes(5.5);
      setTone("Reassuring");
      setCategory("Mental Health");
      setID(30);
    } else if (location.pathname === "/blog/post/agile") {
      setTitle("Advantages of Agile Methodology");
      setMinutes(8.5);
      setTone("Experiential");
      setCategory("Technology/Code");
      setID(31);
    } else if (location.pathname === "/blog/post/best-libraries-node") {
      setTitle("Best Libraries to Use in Your NodeJS Application");
      setMinutes(7.5);
      setTone("Influential");
      setCategory("Technology/Code");
      setID(32);
    } else if (location.pathname === "/blog/post/best-libraries-dot-net-core") {
      setTitle("Best Libraries to Use in Your .NET CORE Application");
      setMinutes(7.5);
      setTone("Educational");
      setCategory("Technology/Code");
      setID(33);
    } else if (location.pathname === "/blog/post/react-usestate-loader") {
      setTitle("Creating a Loader with useState Hooks in React");
      setMinutes(9);
      setTone("Experiential");
      setCategory("Technology/Code");
      setID(34);
    } else if (
      location.pathname === "/blog/post/outdated-libaries-back-end-risk"
    ) {
      setTitle("Why Outdated Libraries Can Pose a Back-End Risk");
      setMinutes(8);
      setTone("Educational");
      setCategory("Technology/Code");
      setID(35);
    } else if (
      location.pathname === "/blog/post/upgrade-to-next-after-react19"
    ) {
      setTitle("Upgrade to Next.js After React 19??");
      setMinutes(9);
      setTone("Unbiased/AI-Prompted");
      setCategory("Technology/Code");
      setID(36);
    } else if (
      location.pathname ===
      "/blog/post/using-debounce-and-throttle-effectively-in-react"
    ) {
      setTitle("How to Use Debounce/Throttle Properly in React");
      setTone("Educational");
      setMinutes(8.5);
      setCategory("Technology/Code");
      setID(37);
    } else if (
      location.pathname === "/blog/post/criticism-of-intercultural-marriages"
    ) {
      setTitle(
        "A Criticism of Inter-Cultural Marriages and an Explanation of the Afterlife"
      );
      setTone("Straight-Forward");
      setMinutes(9);
      setCategory("Faith/Family");
      setID(38);
    } else if (location.pathname === "/blog/post/ramadan-is-difficult") {
      setTitle("Ramadan is difficult. Fasting is difficult!");
      setTone("Straight-Forward");
      setMinutes(9);
      setCategory("Faith/Religion");
      setID(39);
    } else {
      setTitle("The Most Powerful Verses Of The Quran");
      setTone("Enlightening");
      setMinutes(7);
      setCategory("Faith/Religion");
      setID(21);
    }
  }, []);

  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }
  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = true;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  // call this to Disable
  function disableScroll() {
    window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
    window.addEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener("touchmove", preventDefault, wheelOpt);
    window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  let [htmlFileString, setHtmlFileString] = useState();

  async function fetchHtml() {
    if (location.pathname === "/blog/post/dealing-with-depression") {
      setHtmlFileString(await (await fetch(perf1)).text());
    } else if (location.pathname === "/blog/post/dealing-with-fear") {
      setHtmlFileString(await (await fetch(perf2)).text());
    } else if (location.pathname === "/blog/post/meditation-Part-1") {
      setHtmlFileString(await (await fetch(perf3)).text());
    } else if (location.pathname === "/blog/post/get-things-done") {
      setHtmlFileString(await (await fetch(perf4)).text());
    } else if (location.pathname === "/blog/post/") {
      setHtmlFileString(await (await fetch(perf3)).text());
    } else if (location.pathname === "/blog/post/dealing-with-boredom") {
      setHtmlFileString(await (await fetch(perf5)).text());
    } else if (location.pathname === "/blog/post/desire-is-not-your-enemy") {
      setHtmlFileString(await (await fetch(perf6)).text());
    } else if (location.pathname === "/blog/post/what-makes-you-work") {
      setHtmlFileString(await (await fetch(perf7)).text());
    } else if (location.pathname === "/blog/post/three-kinds-of-fame") {
      setHtmlFileString(await (await fetch(perf8)).text());
    } else if (location.pathname === "/blog/post/shiva-vs-krishna") {
      setHtmlFileString(await (await fetch(perf9)).text());
    } else if (location.pathname === "/blog/post/power-of-prayer") {
      setHtmlFileString(await (await fetch(perf10)).text());
    } else if (location.pathname === "/blog/post/end-to-religious-dogmatism") {
      setHtmlFileString(await (await fetch(perf11)).text());
    } else if (location.pathname === "/blog/post/untying-the-knot") {
      setHtmlFileString(await (await fetch(perf12)).text());
    } else if (location.pathname === "/blog/post/dealing-with-OCD") {
      setHtmlFileString(await (await fetch(perf13)).text());
    } else if (
      location.pathname === "/blog/post/dealing-with-thought-broadcasting"
    ) {
      setHtmlFileString(await (await fetch(perf14)).text());
    } else if (location.pathname === "/blog/post/the-ultimate-solution") {
      setHtmlFileString(await (await fetch(perf15)).text());
    } else if (
      location.pathname === "/blog/post/dealing-with-negative-emotions"
    ) {
      setHtmlFileString(await (await fetch(perf16)).text());
    } else if (location.pathname === "/blog/post/dealing-with-emotional-hurt") {
      setHtmlFileString(await (await fetch(perf17)).text());
    } else if (
      location.pathname === "/blog/post/dealing-with-spiritual-awakenings"
    ) {
      setHtmlFileString(await (await fetch(perf18)).text());
    } else if (location.pathname === "/blog/post/skanda-vs-brahma") {
      setHtmlFileString(await (await fetch(perf19)).text());
    } else if (location.pathname === "/blog/post/personal-demons") {
      setHtmlFileString(await (await fetch(perf20)).text());
    } else if (location.pathname === "/blog/post/the-most-powerful-verses") {
      setHtmlFileString(await (await fetch(perf21)).text());
    } else if (location.pathname === "/blog/post/wrath-vs-love-of-god") {
      setHtmlFileString(await (await fetch(perf22)).text());
    } else if (location.pathname === "/blog/post/the-concept-of-will-part-1") {
      setHtmlFileString(await (await fetch(perf23)).text());
    } else if (location.pathname === "/blog/post/the-concept-of-will-part-2") {
      setHtmlFileString(await (await fetch(perf24)).text());
    } else if (location.pathname === "/blog/post/being-a-good-muslim") {
      setHtmlFileString(await (await fetch(perf25)).text());
    } else if (location.pathname === "/blog/post/the-latifas") {
      setHtmlFileString(await (await fetch(perf26)).text());
    } else if (location.pathname === "/blog/post/honouring-our-parents") {
      setHtmlFileString(await (await fetch(perf27)).text());
    } else if (location.pathname === "/blog/post/loving-your-hubby") {
      setHtmlFileString(await (await fetch(perf28)).text());
    } else if (location.pathname === "/blog/post/loving-your-wifey") {
      setHtmlFileString(await (await fetch(perf29)).text());
    } else if (location.pathname === "/blog/post/dealing-with-addiction") {
      setHtmlFileString(await (await fetch(perf30)).text());
    } else if (location.pathname === "/blog/post/agile") {
      setHtmlFileString(await (await fetch(perf31)).text());
    } else if (location.pathname === "/blog/post/best-libraries-node") {
      setHtmlFileString(await (await fetch(perf32)).text());
    } else if (location.pathname === "/blog/post/best-libraries-dot-net-core") {
      setHtmlFileString(await (await fetch(perf33)).text());
    } else if (location.pathname === "/blog/post/react-usestate-loader") {
      setHtmlFileString(await (await fetch(perf34)).text());
    } else if (
      location.pathname === "/blog/post/outdated-libaries-back-end-risk"
    ) {
      setHtmlFileString(await (await fetch(perf35)).text());
    } else if (
      location.pathname === "/blog/post/upgrade-to-next-after-react19"
    ) {
      setHtmlFileString(await (await fetch(perf36)).text());
    } else if (
      location.pathname ===
      "/blog/post/using-debounce-and-throttle-effectively-in-react"
    ) {
      setHtmlFileString(await (await fetch(perf37)).text());
    } else if (
      location.pathname === "/blog/post/criticism-of-intercultural-marriages"
    ) {
      setHtmlFileString(await (await fetch(perf38)).text());
    } else if (location.pathname === "/blog/post/ramadan-is-difficult") {
      setHtmlFileString(await (await fetch(perf39)).text());
    } else {
      setHtmlFileString(await (await fetch(perf21)).text());
    }
  }

  return (
    // backgroundImage: 'linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%'
    <div className="long-container">
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta
          property="og:description"
          content={`Check out this article from ${category} on matkhan.net`}
        />
        <meta
          property="og:image"
          content="https://matkhan-express-7badb55a96b5.herokuapp.com/mmk-favicon-design.png"
        />
        <meta
          property="og:url"
          content={`https://www.matkhan.net${location.pathname}`}
        />
        <meta property="og:type" content="article" />
      </Helmet>
      <div
        class="row"
        style={{
          paddingTop: "70px",
          fontVariant: "small-caps",
          color: "white",
          // backgroundColor: 'white'
        }}
      >
        {" "}
        <span className="category-title" style={{ fontSize: "15px" }}>
          {category}
        </span>{" "}
        <hr
          style={{
            border: 0,
            height: 0,
            marginTop: "10px",
            width: "80%",
            textAlign: "left",
            boxShadow: "0 0 1px 2px white",
          }}
        />{" "}
      </div>
      <div width="100%" />
      <div
        className="post"
        style={{
          paddingTop: "20px",
          fontSize: "large",
          textAlign: "left",
          width: "10%;",
          backgroundImage:
            category === "Mental Health"
              ? "linear-gradient(120deg, blue 0%, orange 100%"
              : category === "Faith/Religion"
              ? "linear-gradient(to top, green 0%, gold 100%)"
              : category === "General"
              ? "linear-gradient(to top, #30cfd0 0%, #330867 100%)"
              : category === "Faith/Family"
              ? "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"
              : "",
          backgroundColor: category === "Technology/Code" ? "inherit" : "red",
        }}
      >
        <div class="post-meta">
          <div
            className="row animation"
            style={{
              fontSize: "30px;",
              backgroundImage:
                "linear-gradient(to right, #ff8177 0%, #ff867a 0%, #ff8c7f 21%, #f99185 52%, #cf556c 78%, #b12a5b 100%)",
              // width: "100%"
              width: "auto",
            }}
          >
            <div>
              <div
                className={
                  category === "Occult/Spirituality"
                    ? "tone tone-occult"
                    : category === "Faith/Religion"
                    ? "tone tone-religion"
                    : category === "General"
                    ? "tone tone-general"
                    : category === "Technology/Code"
                    ? "tone tone-code"
                    : category === "Faith/Family"
                    ? "tone tone-family"
                    : "tone"
                }
                style={{
                  width: "80%",
                  float: "left",
                  fontFamily: "MedievalFont",
                  // backgroundImage: turf1,
                }}
              >
                <h2
                  className="toneCategory"
                  style={{
                    lineHeight: "inherit",
                    marginLeft: "15px",
                    paddingLeft: "15px",
                    textDecoration: "underline",
                    fontWeight: "900",
                  }}
                >
                  <i>{title}</i>
                </h2>
              </div>
            </div>
          </div>
          <div
            style={{
              // 1. Layout & Centering the Card itself
              display: "flex",
              flexDirection: "column",
              gap: "12px", // Space between the "Time" row and the "Tone" row
              width: "fit-content",
              minWidth: "300px", // Gives it a nice shape
              margin: "0 auto", // Centers the div horizontally
              marginTop: "15px",
              // 2. The "Glassmorphism" Design
              backgroundColor: "rgba(255, 255, 255, 0.15)", // Very transparent white
              backdropFilter: "blur(10px)", // The blur effect
              WebkitBackdropFilter: "blur(10px)", // Safari support
              border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border
              borderRadius: "16px",
              padding: "20px",
              boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
              color: "inherit", // Inherits text color from your background
            }}
          >
            {/* Row 1: Average Read Time */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5
                style={{
                  margin: 0,
                  fontSize: "16px",
                  fontWeight: "normal",
                  opacity: 0.8,
                }}
              >
                Average Read Time:
              </h5>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                {minutes} minutes
              </span>
            </div>

            {/* Row 2: Tone */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5
                style={{
                  margin: 0,
                  fontSize: "16px",
                  fontWeight: "normal",
                  opacity: 0.8,
                }}
              >
                Tone:
              </h5>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
              >
                {tone}
              </span>
            </div>
          </div>
          {/* <text text-anchor="left" x="85" y="15" font-size="17" fill="url(#wave)" fill-opacity="1">{'${minutes} minutes'}</text> */}
          {/* <svg viewBox="0 0 100 20">
            <defs>
              <linearGradient id="gradient">
                <stop color="#000" />
              </linearGradient>
              <pattern
                id="wave"
                x="0"
                y="-0.5"
                width="100%"
                height="100%"
                patternUnits="userSpaceOnUse"
              >
                <path
                  id="wavePath"
                  d="M-40 9 Q-30 7 -20 9 T0 9 T20 9 T40 9 T60 9 T80 9 T100 9 T120 9 V20 H-40z"
                  mask="url(#mask)"
                  fill="white"
                >
                  <animateTransform
                    attributeName="transform"
                    begin="0s"
                    dur="1.5s"
                    type="translate"
                    from="0,57"
                    to="40,75"
                    repeatCount="indefinite"
                  />
                </path>
              </pattern>
            </defs>
            <text
              text-anchor="middle"
              x="50"
              y="15"
              font-size="17"
              fill="url(#wave)"
              fill-opacity="1"
            >
              {"Tone:"}
            </text>
            <text
              text-anchor="middle"
              x="145"
              y="1"
              font-size="17"
              fill="url(#wave)"
              fill-opacity="1"
            >
              {tone}
            </text>
            {tone && (
              <>
                <text
                  text-anchor="middle"
                  x="50"
                  y="15"
                  font-size="17"
                  fill="yellow"
                  stroke="white"
                  fill-opacity="0.1"
                >
                  {"Tone:"}
                </text>
                <text
                  text-anchor="left"
                  x="85"
                  y="17"
                  font-size="17"
                  fill="url(#wave)"
                  fill-opacity="1"
                >
                  {tone}
                </text>
              </>
            )}{" "} */}
          {/* </svg> */}

          {/* <b>
                        <div className="row">
                            <div className="tone" style={{
                                padding: '15px',
                                fontSize: 'large',
                                fontVariantCaps: 'all-small-caps',
                                color: 'white'
                            }}><span>Tone: </span><span>Encouraging</span></div>
                        </div>
                    </b> */}
          <div
            className="row"
            style={{
              paddingTop: "20px",
              marginTop: "20px",
              backgroundImage:
                "linear-gradient(to right, #43e97b 0%, #38f9d7 100%)",
            }}
          >
            {/* <div className="addthis_inline_share_toolbox" style={{ paddingTop: "20px" }}></div> */}
            <div
              class="sharethis-inline-share-buttons"
              style={{ marginLeft: "0px", zIndex: 0 }}
            ></div>
          </div>
        </div>
        <div
          className="post-body"
          ref={nudgeRef}
          style={{
            marginTop: "15px",
            // backgroundImage: 'linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)',
            paddingTop: "45px",
            paddingLeft: "5px",
            borderBottom: "2px solid black",
          }}
        >
          {props.slug ? (
            <div dangerouslySetInnerHTML={{ __html: htmlFileString }}></div>
          ) : (
            <p>
              Hi this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this idocument.body.document.body
              .document.body.document.body.document.body.document.body.document.body.document.body.
              document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body
              .document.body.document.body.document.body.document.body.document.body.document.body
              .document.body.document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.documen
              .body.document.
              body.document.body.document.body.document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.bod
              y.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body
              .document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.docum
              ent.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.do
              cument.body.document.body.document.body.document.body.document.body.document.body.documen
              t.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.
              body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body
              .document.body.document.body.document.body.document.body
              .document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document
              .body.document.body.document.body.document.body.document.body.document.body.document.body
              .document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.document.body.s
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheenHi this is matheenHi this is matheenHi
              this is matheenHi this is matheenHi this is matheenHi this is
              matheenHi this is matheen
            </p>
          )}
          <div className="post-partition" style={{ width: "inherit" }}></div>
          {id > 0 && <Comment postId={String(id)} />}
          {/* <div className="post-partition2" style={{ width: 'inherit' }}></div> */}
        </div>
      </div>
    </div>
  );
};
